import * as mqtt from 'mqtt/dist/mqtt.js';
var MQTT = /** @class */ (function () {
    function MQTT(url, options, topics, cb) {
        this.url = url;
        this.options = options;
        this.topics = topics;
        this.cb = cb;
        this.fns = {};
        this.init();
    }
    MQTT.prototype.init = function () {
        this.client = mqtt.connect(this.url, this.options);
        this.client.on('message', this.cb);
        let _this = this;
        /* @description: 将主题订阅修改到connect连接成功事件中，主要是解决断网重连后，订阅主题
         * @author: 宋建国
         * @date: 2021-06-13 16:52:44
         * @version: V1.0
        */
        this.client.on('connect',function(){
            if (_this.topics) {
                _this.client.subscribe(_this.topics.split(','));
            }
        });
    };
    MQTT.prototype.publish = function (topic, message) {
        this.client.publish(topic, message);
    };
    MQTT.prototype.close = function () {
        this.client.end();
    };
    return MQTT;
}());
export { MQTT };
//# sourceMappingURL=mqtt.js.map


// WEBPACK FOOTER //
// ./src/components/topologycomponent/mqtt.js